// src/utils/statusBadge.ts

export const getStatusBadgeClass = (status?: string): string => {
    if (!status) return "bg-[#F5F5F5] text-[#424242] border border-[#E0E0E0]"; // fallback
  

    switch (status.toLowerCase()) {
      case "draft":
        return "!bg-[#FFF3E0] !text-[#E65100] !border !border-[#FFE0B2]"; // warm orange-yellow
      case "in_review":
        return "!bg-[#E3F2FD] !text-[#1565C0] !border border-[#BBDEFB]"; // soft blue
      case "ready":
        return "!bg-[#E8F5E9] !text-[#2E7D32] !border !border-[#C8E6C9]"; // green
      case "sent":
        return "!bg-[#EDE7F6] !text-[#4527A0] !border !border-[#D1C4E9]"; // purple
      case "pending":
        return "!bg-[#FFE2E2] !text-[#C10007] !border !border-[#FFECB3]"; // yellow
      case "failed":
        return "!bg-[#FFEBEE] !text-[#C62828] !border !border-[#FFCDD2]"; // red
      case "delivered":
        return "!bg-[#ECEFF1] !text-[#37474F] !border !border-[#CFD8DC]"; // gray-blue
      case "approved":
        return "!bg-[#E6FFFA] !text-[#00796B] !border !border-[#B2DFDB]"; // teal green
      case "annexure":
        return "!bg-[#E3F2FD] !text-[#1565C0] !border border-[#BBDEFB]";
      default:
        return "!bg-[#F5F5F5] !text-[#424242] !border !border-[#E0E0E0]"; // neutral gray fallback
    }
  };
  